import { css, liquid, misc } from "./category";
import { blobToBase64 } from "./lib";
import { DirectUploadQueue } from "../../../shared/direct_upload_queue";
import CustomizationRequest from "./request";

export class CustomizationSave {
  constructor(toast) {
    this.customizations = { ...liquid.values, ...css.values, ...misc.values };
    this.directUploadQueue = new DirectUploadQueue();
    this.store = window.blobs || [];
    this.toast = toast;
  }

  async perform(siteId) {
    // Check if the logo is missing in customizations and also not present in the DOM
    const isLogoImageMissing = !this.customizations.logo &&
      !document.querySelector('.brand-logo img')?.src;

    // Check if the company text is missing in customizations and also not present in the DOM
    const isCompanyTextMissing = !this.customizations.company &&
      !document.querySelector('input[name="company"]')?.value.trim();

    // Trigger the error only if both are missing
    if (isLogoImageMissing && isCompanyTextMissing) {
      this.toast.error.show(
        "Missing Information",
        "Logo section cannot be blank. Select an image or enter logo text."
      );

      const event = new CustomEvent('logo-section-blank');
      window.dispatchEvent(event);

      return;
    }

    await this.#handleLogo();
    await this.#handleCustomImages();
    await CustomizationRequest.turboFetch(`/sites/${siteId}/site_builder`, {
      method: 'PUT',
      body: JSON.stringify(this.customizations)
    });
  }

  async #handleLogo() {
    if (this.customizations.logo && !this.customizations.logo.id) {
      const blob = window.blobs.logo;
      const file = new File([blob], this.customizations.logo.name, { type: blob.type });
      const uploader = document.querySelector("#s3_logo_form");

      this.directUploadQueue.push({ file, uploader });

      delete this.customizations.logo;

      await this.directUploadQueue.flush();
    }
  }

  async #handleCustomImages() {
    for (const image of ['hero', 'footer-one', 'footer-two']) {
      const data = this.customizations[image];
      if (!data) continue;

      const { type, id } = data;
      switch (type) {
        case 'library':
          this.customizations[image] = { id, type };
          break;
        case 'direct-upload': {
          const identifier = `[data-site-builder--custom-images--actions-key-value="${image}"] form.s3_uploader_form`;
          const uploader = document.querySelector(identifier);
          const { file } = this.store[image];
          this.directUploadQueue.push({ file, uploader });
          delete this.customizations[image];
          break;
        }
      }
    }
    await this.directUploadQueue.flush();
  }

  async convertLogoToBase64(logo) {
    if (!logo) return logo;

    return blobToBase64(logo);
  }
}
